import FAQCard from './FAQCard';
import ContactSupport from './ContactSupport';
import { FAQCategory } from '../../utils/types';

interface FAQSectionProps {
  faqCategories: FAQCategory[];
}

const FAQSection = ({ faqCategories }: FAQSectionProps) => {
  return (
    <div className="space-y-4">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-foreground mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Find quick answers to common questions about our services, platform,
          and policies.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {faqCategories.map((category, index) => (
          <FAQCard key={index} category={category} />
        ))}
      </div>

      <ContactSupport />
    </div>
  );
};

export default FAQSection;
